<template>
    <i18n :path="`account.agree-tou${action ? '-action' : ''}`" tag="p" class="agree-tou">
        <template v-if="action" v-slot:action>
            <span class="tou-agree-action">{{ action }}</span>
        </template>
        <template v-slot:touLink>
            <a id="touAccept" data-cy="link-terms" :href="touUrl" target="_blank" rel="external">{{
                $t('account.tou')
            }}</a>
        </template>
        <template v-slot:privacyLink>
            <a id="privacyAccept" data-cy="link-privacy" :href="privacy" target="_blank" rel="external">{{
                $t('account.privacy')
            }}</a>
        </template>
    </i18n>
</template>

<script>
import legalLinks from '@/config/terms-link';

export default {
    name: 'TermsLinks',
    props: {
        action: {
            type: String,
            default: '',
        },
    },
    computed: {
        touUrl() {
            if (this.region === 'one') {
                return `/account/${this.$route.params.locale}/global/terms-of-use`;
            }
            return legalLinks[this.region].tou.replace('{locale}', this.$i18n.locale);
        },
        privacy() {
            if (this.region === 'one') {
                return `/account/${this.$route.params.locale}/global/privacy-policy`;
            }
            return legalLinks[this.region].privacy.replace('{locale}', this.$i18n.locale);
        },
    },
};
</script>
<style lang="less" scoped>
.tou-agree-action {
    text-transform: uppercase;
}
</style>
